<template>
  <div class="container">
    <div class="formtitle">绑定企业</div>
    <div class="companybox">
      <h2>{{ qymc }}</h2>
      <p>税号：{{ qysh }}</p>
    </div>
    <div class="unbindingbtn" @click="unbinding">解绑</div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      qymc:sessionStorage.getItem("qymc"),
      qysh:sessionStorage.getItem("qysh")
    }
  },
  methods:{
    unbinding(){
      let dataJson = {
        qymc:sessionStorage.getItem("qymc"),
        qysh:sessionStorage.getItem("qysh")
      }
      this.axios.post("/system/user/jbQy",dataJson)
      .then(res=>{
        if(res.code==200){
          sessionStorage.removeItem("qymc")
          sessionStorage.removeItem("qysh")
          this.$toast("解绑企业成功")
          this.$router.replace("/bindcompany")
        }else{
          this.$toast(res.msg)
        }
      })
    }
  }
}
</script>

<style src="@/assets/css/css.css" scoped></style>
<style scoped>

</style>